module.exports = __webpack_public_path__ + "img/logo_jcvm.c473c493.png";